export const PDFWrapper = {
    justifyContent:"center",
    gap:"24px"
}